import { Map } from 'immutable';
import {
  GET_PASTCASELIST,
  GET_CURRENTCASELIST,
  GET_INVENTORYLIST,
  GET_WORKFLOWCASEDETAILS,
  GET_ACTIVESTAGENAME,
  SET_LOADING,
  GE_ACTIVECASEID,
  GE_RELOCATIONPLANDETAILS,
  GET_INVENTORYROOMS,
  GET_UNITLISTT,
  GET_ADMINUNITLIST,
  GET_SERVICELIST,
  GET_TENURELIST,
  GET_CONTACTDETAILS,
  SAVE_RELOCATIONPLANID,
  SAVE_ITEMS,
  GET_RELOCATIONDETAILSVIEW,
  GET_DEPTITEMS,
  SAVE_CASEID,
  GE_SAVEACTIVECASEID,
  SAVERESERVE,
  SAVEFOREIGNDEFENSE,
  UPDATE_INVENTORYLIST,
} from '../actions/cases';
import { RelocationDetailsViewModel } from '../../common/Models/RelocationDetailsViewModel/RelocationDetailsViewModel';
import { cloneDeep } from 'lodash';

const initialState = Map({
  pastCaseList: [],
  currentCaseList: [],
  inventoryList: [],
  workFlowCaseDetails: '',
  activeStageName: "",
  loading: false,
  activeCaseId: 0,
  relocationPlanDetails: '',
  inventoryRooms: {},
  contactDetails: {},
  locationList: [],
  unitList: [],
  adminUnitList: [],
  serviceList: [],
  tenureList: [],
  relocationPlanId: "",
  relocationDetailsView: RelocationDetailsViewModel,
  deptItems: [],
  caseId: 0,
  uptActiveCaseId: 0,
  reserve: "",
  foreignDefense: ""
});

const actionsMap = {
  [GET_PASTCASELIST]: (state, action) => {
    return state.set('pastCaseList', action.pastCaseList);
  },
  [GET_CURRENTCASELIST]: (state, action) => {
    return state.set('currentCaseList', action.currentCaseList);
  },
  [GET_INVENTORYLIST]: (state, action) => {
    return state.set('inventoryList', action.inventoryList);
  },
  [GET_WORKFLOWCASEDETAILS]: (state, action) => {
    return state.set('workFlowCaseDetails', action.workFlowCaseDetails);
  },
  [GET_ACTIVESTAGENAME]: (state, action) => {
    return state.set('activeStageName', action.activeStageName);
  },
  [SET_LOADING]: (state, action) => {
    return state.set('loading', action.loading);
  },
  [GE_ACTIVECASEID]: (state, action) => {
    return state.set('activeCaseId', action.activeCaseId);
  },
  [GE_RELOCATIONPLANDETAILS]: (state, action) => {
    return state.set('relocationPlanDetails', action.relocationPlanDetails);
  },
  [GET_INVENTORYROOMS]: (state, action) => {
    return state.set('inventoryRooms', action.inventoryRooms);
  },
  [GET_CONTACTDETAILS]: (state, action) => {
    return state.set('contactDetails', action.contactDetails);
  },
  [GET_UNITLISTT]: (state, action) => {
    return state.set('unitList', action.unitList);
  },
  [GET_ADMINUNITLIST]: (state, action) => {
    return state.set('adminUnitList', action.adminUnitList);
  },
  [GET_SERVICELIST]: (state, action) => {
    return state.set('serviceList', action.serviceList);
  },
  [GET_TENURELIST]: (state, action) => {
    return state.set('tenureList', action.tenureList);
  },
  [GET_RELOCATIONDETAILSVIEW]: (state, action) => {
    return state.set('relocationDetailsView', action.state);
  },
  [GET_DEPTITEMS]: (state, action) => {
    return state.set('deptItems', action.deptItems);
  },
  [SAVE_RELOCATIONPLANID]: (state, action) => {
    return state.set('relocationPlanId', action.data);
  },
  [SAVE_ITEMS]: (state, action) => {
    const newInventoryId = action.newRoom.InventoryID;
    const newInventoryRoomId = action.newRoom.InventoryRoomID;

    // created the nested copy of the original state
    const newInventory = { ...state.get('inventoryRooms') };
    const newInventoryRooms = [...newInventory[newInventoryId]]
    // find the inventory room key that needs to be replaced
    const inventoryKey = newInventoryRooms.findIndex(room => room.InventoryRoomID === newInventoryRoomId);
    // if it's custom room, then replace custom room to current room
    if (inventoryKey === -1) {
      const customRoomKey = newInventoryRooms.findIndex(room => room.RoomType === -1);
      newInventoryRooms[customRoomKey] = action.newRoom;
    } else {
      newInventoryRooms[inventoryKey] = action.newRoom;
    }
    newInventory[newInventoryId] = newInventoryRooms;
    return state.set('inventoryRooms', newInventory);
  },
  [SAVE_CASEID]: (state, action) => {
    return state.set('caseId', action.data);
  },
  [GE_SAVEACTIVECASEID]: (state, action) => {
    return state.set('uptActiveCaseId', action.activeCaseId);
  },
  [SAVERESERVE]: (state, action) => {
    return state.set('reserve', action.data);
  },
  [SAVEFOREIGNDEFENSE]: (state, action) => {
    return state.set('foreignDefense', action.data);
  },
  [UPDATE_INVENTORYLIST]: (state, action) => {
    const { updatedRoom } = action;
    const { InventoryInventoryGroups } = updatedRoom;
    const inventoryList = cloneDeep(state.get('inventoryList'));
    const inventoryID = parseInt(updatedRoom.InventoryID);
    const currentInventoryIndex = inventoryList.findIndex(inv => inv.InventoryID === inventoryID);
    const currentInventory = inventoryList[currentInventoryIndex];
    const vehicleList = InventoryInventoryGroups.map(vehicle => {
      const currentVehicle = vehicle.Vehicles;
      return {
        MakeAndModel: currentVehicle.Make + ' ' + currentVehicle.ModelName,
        VehiclePartyAssetID: currentVehicle.VehiclePartyAssetID,
      }
    })
    currentInventory.Vehicles = vehicleList;
    return state.set('inventoryList', inventoryList);
  }
};

export default function facilities(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
